import ConditionalLogic from './ConditionalLogic';

document.addEventListener('DOMContentLoaded', () => {
  // Initialisation des champs avec logique conditionnelle
  const conditionalFields = document.querySelectorAll('.js-form-field[data-conditional-logic]');

  if (conditionalFields.length === 0) {
    return;
  }

  const instances = [];

  // Créer une instance pour chaque champ conditionnel
  conditionalFields.forEach(field => {
    try {
      const instance = new ConditionalLogic(field);
      instances.push(instance);
    } catch (error) {
      console.error('Erreur lors de l\'initialisation du champ conditionnel:', error);
    }
  });
});
